






















import { Component, Vue } from 'vue-property-decorator';
import { namespace } from "vuex-class";
import RIDCService from "@/services/request/RIDCService";
import RIDC_DTO from "@/dto/request/ridc/RIDC_DTO";
import { processError } from "@/utils/ComponentUtils";
import RouteNames from "@/router/RouteNames";
import { PublicRIDCContractorDTO } from "@/dto/request/ridc/PublicRIDCContractorDTO";

const AppModule = namespace("App");

@Component({})
export default class RIDC extends Vue {
  @AppModule.Action
  private startLoading!: () => void

  @AppModule.Action
  private stopLoading!: () => void

  request: RIDC_DTO | null = null;

  mounted(): void {
    this.loadRequest();
  }

  get id(): number {
    return Number.parseInt(this.$route.params.id);
  }

  loadRequest(): void {
    this.startLoading();
    RIDCService.getById(this.id).then(
        ok => {
          this.request = ok.data;
          this.stopLoading();
        },
        err => {
          this.stopLoading();
          processError(err, this);
        }
    )
  }

  goToContractor(contractor: PublicRIDCContractorDTO): void {
    this.$router.push({ name: RouteNames.RIDC_CONTRACTOR, params: { id: `${contractor.id}` }});
  }
}
